import UserProfile from '../../Pages/User/ProfilePage/UserProfile'

var userProfileRoutes = [
  {
    path: '/profile',
    navBarHeading: 'User Profile',
    component: UserProfile,
    layout: '/admin',
    redirect: true,
  },
]
export default userProfileRoutes
